import { render, staticRenderFns } from "./OdooSupplierDialog.vue?vue&type=template&id=580f72c6&scoped=true"
import script from "./OdooSupplierDialog.vue?vue&type=script&lang=js"
export * from "./OdooSupplierDialog.vue?vue&type=script&lang=js"
import style0 from "./OdooSupplierDialog.vue?vue&type=style&index=0&id=580f72c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f72c6",
  null
  
)

export default component.exports